import React from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Header from '../components/SubHeader-Course';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import '../components/css/buttonStyle.css';
import paper1 from '../components/question-answer-pdf/dsssb_pgt_2014.pdf';
import paper2 from '../components/question-answer-pdf/dsssb_pgt_2015.pdf';
import paper3 from '../components/question-answer-pdf/dsssb_pgt_2018_f.pdf';
import paper4 from '../components/question-answer-pdf/dsssb_pgt_2018_m.pdf';
import paper5 from '../components/question-answer-pdf/dsssb_pgt_2021.pdf';
import add1 from '../components/advertisment/pgtbottom.png';
import add2 from '../components/advertisment/pgtright.png';


function AssistantprofessorCourse (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            <Header />
            <div className="container my-5">
                <div className="row g-4">
                    <div className="col-lg-9">
                        <div className="row g-4">
                            <p>Candidates appearing for the DSSSB Post Graduate Teacher exam must have a focused strategy to ace the exam with a good score. Applicants can practice the DSSSB PGT Previous Year Question Paper for their exam preparations. It helps candidates to understand the exam pattern, question diculty, and subject-wise weightage. By solving DSSSB PGT Previous Year Papers, aspirants can analyse high-weightage topics and align their preparation as per the plan. Referring to the previous year question papers enables candidates to improve speed and accuracy while revising the syllabus eciently. Regular practice of DSSSB PGT previous year papers PDF download strengthens conceptual clarity.</p>
                        </div>

                        <div className="yearbox mt-5 mb-5">
                            <p><b>pgt dsssb Question Paper (Total Tests: 5)</b></p>
                            
                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">DSSSB PGT Exam. 2014</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper1} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">DSSSB PGT Exam. 2015</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper2} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">DSSSB PGT Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper3} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">DSSSB PGT Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper4} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">DSSSB PGT Exam. 2021</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper5} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <h4>DSSSB PGT Recruitment 2025, Eligibility, Selection Process</h4>
                        <p>DSSSB PGT Recruitment 2025: The Delhi Subordinate Services Selection Board (DSSSB) has  released  the  DSSSB  PGT  Notification  2025  online.  The  notification  for  Delhi  Post Graduate  Teacher  was  announced  for  432  teacher  vacancies.  Candidates  can  use  the apply online link from 16 January to 14 February, 2025 at dsssb.gov.in to register for the examination.  The  DSSSB  Post  Graduate  Teacher  Selection  Process  has  only  a  single written examination followed by a document verification round.</p>

                        <h4>DSSSB PGT Recruitment 2025 Overview</h4>
                        <p>Candidates can go through the table below to know about the major highlights related to the DSSSB Teacher Recruitment 2025.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th colspan="2">DSSSB PGT Recruitment 2025 Overview</th>
                                </tr>
                                <tr>
                                    <td>Conducting Body</td>
                                    <td>Delhi Subordinate Services Selection Board (DSSSB)</td>
                                </tr>
                                <tr>
                                    <td>Exam Name</td>
                                    <td>DSSSB PGT Recruitment 2025</td>
                                </tr>
                                <tr>
                                    <td>Posts</td>
                                    <td>Post Graduate Teacher</td>
                                </tr>
                                <tr>
                                    <td>DSSSB PGT Vacancy 2025</td>
                                    <td>432 vacancies</td>
                                </tr>
                                <tr>
                                    <td>Selection Process</td>
                                    <td>
                                        <ul>
                                            <li>Written Exam</li>
                                            <li>Document Verification</li>
                                            <li>Medical Examination</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mode of Exam</td>
                                    <td>Computer-Based Test (Online)</td>
                                </tr>
                                <tr>
                                    <td>Language or Medium</td>
                                    <td>English and Hindi</td>
                                </tr>
                                <tr>
                                    <td>DSSSB PGT Notification 2025</td>	
                                    <td>01 January, 2025</td>
                                </tr>
                                <tr>
                                    <td>Exam Helpdesk No.</td>
                                    <td>+91-011-22370309</td>
                                </tr>
                                <tr>
                                    <td>Official Website</td>	
                                    <td>dsssb.delhi.gov.in</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Recruitment 2025 Important Dates</h4>
                        <p>Candidates can get an idea of the DSSSB Recruitment 2025 dates from the table below.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th colsapn="2">DSSSB Teacher Recruitment 2025 Important Dates</th>
                                </tr>
                                <tr>
                                    <td>Events</td>
                                    <td>DSSSB Teacher Important Dates</td>
                                </tr>
                                <tr>
                                    <td>DSSSB PGT Notification 2025</td>
                                    <td>01 January, 2025</td>
                                </tr>
                                <tr>
                                    <td>DSSSB PGT Teacher Online Application Form Starts</td>
                                    <td>16 January, 2025</td>
                                </tr>
                                <tr>
                                    <td>DSSSB Teacher Online Application Form Filling Ends</td>
                                    <td>14 February, 2025</td>
                                </tr>
                                <tr>
                                    <td>Delhi Post Graduate Teacher Application Form Correction Facility</td>	
                                    <td>To be Announced</td>
                                </tr>
                                <tr>
                                    <td>DSSSB Teacher Exam Date 2025</td>	
                                    <td>To be Announced</td>
                                </tr>
                                <tr>
                                    <td>DSSSB Teacher Admit Card 2025</td>	
                                    <td>To be Announced</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Recruitment 2025 Total Vacancies</h4>
                        <p>The DSSSB PGT Recruitment 2025 has announced a total of 432 vacancies across various subjects. This recruitment drive aims to fill positions for Post Graduate Teachers in the Delhi government schools. Candidates can go through the table below to know about the subject wise DSSSB Post Graduate Teachers.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th colspan="2">DSSSB PGT Vacancy 2025</th>
                                </tr>
                                <tr>
                                    <td>Hindi Male</td>
                                    <td>70</td>
                                </tr>
                                <tr>
                                    <td>Hindi Female</td>	
                                    <td>21</td>
                                </tr>
                                <tr>
                                    <td>Math Male</td>	
                                    <td>21</td>
                                </tr>
                                <tr>
                                    <td>Math Female</td>	
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>Physics Male</td>	
                                    <td>3</td>
                                </tr>
                                <tr>
                                    <td>Physics Female</td>	
                                    <td>2</td>
                                </tr>
                                <tr>
                                    <td>Chemistry Male</td>	
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>Chemistry Female</td>
                                    <td>3</td>
                                </tr>
                                <tr>
                                    <td>Biology Male</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Biology Female</td>	
                                    <td>12</td>
                                </tr>
                                <tr>
                                    <td>Economics Male</td>
                                    <td>60</td>
                                </tr>
                                <tr>
                                    <td>Economics Female</td>	
                                    <td>22</td>
                                </tr>
                                <tr>
                                    <td>Commerce Male</td>
                                    <td>32</td>
                                </tr>
                                <tr>
                                    <td>Commerce Female</td>	
                                    <td>5</td>
                                </tr>
                                <tr>
                                    <td>History Male</td>	
                                    <td>50</td>
                                </tr>
                                <tr>
                                    <td>History Female</td>	
                                    <td>11</td>
                                </tr>
                                <tr>
                                    <td>Geography Male</td>
                                    <td>21</td>
                                </tr>
                                <tr>
                                    <td>Geography Female</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>Political Science Male</td>
                                    <td>59</td>
                                </tr>
                                <tr>
                                    <td>Political Science Female</td>
                                    <td>19</td>
                                </tr>
                                <tr>
                                    <td>Sociology Male</td>
                                    <td>5</td>
                                </tr>
                                <tr>
                                    <td>Total</td>	
                                    <td>432</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Notification 2025 PDF</h4>
                        <p>The DSSSB PGT Notification 2025 has been released for 432 vacancies. The online application process will be open from January 16 to February 14, 2025. Candidates can find detailed information regarding eligibility criteria, age limits, and the selection process in the official notification available on the DSSSB website. Candidates can download the PGT Notification PDF from the official website to know further details about the recruitment process.</p>

                        <h5 class="text-center">DSSSB PGT Notification 2025 - Click Here</h5>

                        <h4>DSSSB PGT Exam Date 2025</h4>
                        <p>The DSSSB PGT Exam Date for 2025 has not yet been officially announced. However, the application period is from January 16 to February 14, 2025, and further details regarding exam dates and timings for all subjects are expected to be released after the application process begins. Candidates must keep an eye on the official DSSSB website or on this page for updates, as the exam date will be communicated soon.</p>

                        <h4>DSSSB PGT Eligibility Criteria 2025</h4>
                        <p>The candidates have to fulfill the basic eligibility criterias as prescribed for them according to DSSSB PGT Recruitment 2025.
                        DSSSB PGT Age Limit 2025</p>
                        <p>The age limit for the DSSSB PGT positions has been set at not exceeding 30 years. However, government servants are eligible for a relaxation of up to 5 years, following the instructions issued by the Central Government. Candidates can know about the application PGT Age Relaxation from the table below.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>Category</th>
                                    <th>DSSSB PGT Age Limit 2025</th>
                                </tr>
                                <tr>
                                    <td>OBC</td>
                                    <td>3 years</td>
                                </tr>
                                <tr>
                                    <td>EWS</td>
                                    <td>5 years</td>
                                </tr>
                                <tr>
                                    <td>SC</td>
                                    <td>5 years</td>
                                </tr>
                                <tr>
                                    <td>ST</td>
                                    <td>5 years</td>
                                </tr>
                                <tr>
                                    <td>PwBD + UR/EWS</td>	
                                    <td>10 years</td>
                                </tr>
                                <tr>
                                    <td>Contractual Employees</td>
                                    <td>Relaxation in upper age as a one-time measure up to the actual time spent as a contractual employee of the same department, subject to a maximum of 5 years will be provided</td>
                                </tr>
                                <tr>
                                    <td>Departmental candidate</td>
                                    <td>Up to 05 years for Group ‘B’ posts (which are in the same line or allied cadres and where a relationship could be established that the service already rendered in a particular post.</td>
                                </tr>
                                <tr>
                                    <td>Ex-Servicemen Group B (Non-Gazetted)</td>	
                                    <td>Period of Military service plus 3 years (Maximum upto the age of 55 years)</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Educational Qualification 2025</h4>
                        <ul>
                            <li>Master Degree in the concerned subject from a recognized University /Institution with at least 50 percent marks in aggregate or equivalent grade.</li>
                            <li>Bachelor of Education (B.Ed.) from a recognized University; OR B.A.B.Ed./B.Sc.B.Ed.</li>
                            <li>OR Three year integrated B.Ed.- M.Ed. from any NCTE recognized institution</li>
                        </ul>

                        <h4>DSSSB PGT Apply Online Link 2025</h4>
                        <p>The Delhi Subordinate Services Selection Board (DSSSB) has commenced the recruitment process for Post Graduate Teachers (PGT). Eligible candidates can now apply online through the official DSSSB website, dsssb.delhi.gov.in/. The online application window will remain open from January 16, 2025, to February 14, 2025.</p>
                        <p>Interested individuals are advised to carefully review the official notification for detailed eligibility criteria, application process, and other essential information before commencing the application process.</p>

                        <h4>Steps to Apply for DSSSB PGT Application Form 2025</h4>
                        <p>The DSSSB PGT Application Form 2025 can be filled out online through the official DSSSB website. Candidates must register, fill in the application form with accurate details, upload the necessary documents, and pay the application fee (if applicable). Step 1: Visit the Official Website: Go to the official DSSSB website, dsssb.delhi.gov.in Step 2: Register yourself on the website by providing basic details. Step 3: Login using your registered credentials. Step 4: Fill out the Application Form of DSSSB PGT by entering personal, educational, and other relevant information accurately. Step 5: Upload scanned copies of your photograph, signature, and necessary certificates. Step 6: Pay the application fee online through the available payment gateways (if applicable). Step 7: Review all the information entered and submit the Delhi PGT application form. Step 8 : Download and print a copy of the submitted application form for future reference.</p>

                        <h4>DSSSB PGT Application Fee 2025</h4>
                        <p>The DSSSB PGT Application Fee 2025 is typically Rs. 100 for General, OBC, and EWS categories. SC/ST/PH/Women candidates are usually exempt from paying the application fee.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>DSSSB PGT Application Fee</th>
                                </tr>
                                <tr>
                                    <td>Category</td>
                                    <td>Application Fees</td>
                                </tr>
                                <tr>
                                    <td>General</td>
                                    <td>Rs. 100/</td>
                                </tr>
                                <tr>
                                    <td>OBC</td>
                                    <td>Rs. 100/</td>
                                </tr>
                                <tr>
                                    <td>Women/SC/ST</td>
                                    <td>Exempted</td>
                                </tr>
                                <tr>
                                    <td>PH/Ex-servicemen</td>	
                                    <td>Exempted</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Exam Pattern 2025</h4>
                        <p>The DSSSB PGT Exam Pattern 2025 is going to have a single tier that will judge a candidate’s ability. The written examination will have two sections, the General Aptitude section and the other will be of subject concerned. Here are the key highlights of the exam pattern for Delhi Post Graduate Teachers 2025.</p>
                        <ul>
                            <li>The DSSSB PGT 2025 is going to be held in the computer-based examination</li>
                            <li>Section I will be held for 100 marks while the second section which will be the subject centric will be conducted for 200 marks</li>
                            <li>Negative Marking will be applicable and a deduction of 0.25 marks will be made for each wrong Multiple Choice Question (MCQ) answer</li>
                        </ul>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>Section</th>
                                    <th>Subject</th>
                                    <th>Total Question</th>	
                                    <th>Total Marks</th>
                                    <th>Duration</th>
                                </tr>
                                <tr>
                                    <td>Section I</td>
                                    <td>General Aptitude</td>	
                                    <td>100</td>
                                    <td>100</td>
                                    <td>3 hours</td>
                                </tr>
                                <tr>
                                    <td>Section II</td>
                                    <td>Post Graduation qualification and teaching methodology required for the post</td>
                                    <td>200</td>
                                    <td>200</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Total</td>
                                    <td></td>
                                    <td>300</td>
                                    <td>300</td>
                                    <td>3 hours</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Syllabus 2025</h4>
                        <p>The DSSSB PGT Syllabus 2025 encompasses a wide range of subjects to assess the candidates' knowledge and aptitude. The syllabus includes core subjects specific to the respective PGT subjects (e.g., History, Geography, Science for History, Geography, and Science PGTs), along with essential general knowledge, language proficiency (English and Hindi), and analytical skills.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <td>Subject</td>
                                    <td>DSSSB PGT Topics</td>
                                </tr>
                                <tr>
                                    <td>Mental Ability & Reasoning Ability</td>
                                    <td>Analogy Series Coding-Decoding Blood Relations Direction Sense Logical Venn Diagrams Data Sufficiency Syllogism Decision Making Analytical Reasoning</td>
                                </tr>
                                <tr>
                                    <td>General Awareness</td>
                                    <td>Current Affairs (National & International) History of India Indian Polity & Constitution Indian Geography Indian Economy Science & Technology Sports Culture & Heritage Important Days & Events</td>
                                </tr>
                                <tr>
                                    <td>English Language & Comprehension</td>	
                                    <td>Reading Comprehension Grammar & Usage Vocabulary Synonyms & Antonyms Sentence Correction Error Spotting Cloze Test One Word Substitution Idioms & Phrases</td>
                                </tr>
                                <tr>
                                    <td>Hindi Language & Comprehension</td>
                                    <td>Reading Comprehension Grammar & Usage (Vyakaran) Vocabulary (Shabdavali) Synonyms & Antonyms (Samarthak & Virudharthak) Sentence Correction (Vakya Sudhar) Error Spotting (Dosha Alan) Lovkhat (Folklore) Sahitya (Literature)</td>
                                </tr>
                                <tr>
                                    <td>Numerical Aptitude & Data Interpretation</td>	
                                    <td>Number Systems Percentages Profit & Loss Simple & Compound Interest Ratio & Proportion Time & Work Time & Distance Average Data Interpretation (Tables, Graphs, Charts)</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Salary 2025</h4>
                        <p>The position offers a salary range of ₹47,600 to ₹1,51,100, classified under Pay Level 8. This role falls within Group 'B' of the General Central Service, characterized as<br />
                        Non-Ministerial and Non-Gazetted. Below is the detailed salary table for the DSSSB PGT Recruitment 2025.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>DSSSB PGT Salary Structure 2025</th>
                                </tr>
                                <tr>
                                    <td colspan="2">Pay Level of Posts</td>
                                    <td>Pay Level 8</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Payscale</td>	
                                    <td>Rs.47,600 to Rs.1,51,100</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Grade Pay</td>
                                    <td>4800</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Basic pay</td>
                                    <td>Rs. 47,600</td>
                                </tr>
                                <tr>
                                    <td rowspan="3">HRA (depending on the city)</td>
                                    <td>X Cities (24%)</td>
                                    <td>11,424</td>
                                </tr>
                                <tr>
                                    <td>Y Cities (16%)</td>
                                    <td>7,616</td>
                                </tr>
                                <tr>
                                    <td>Z Cities (8%)</td>	
                                    <td>3,808</td>
                                </tr>
                                <tr>
                                    <td colspan="2">DA (Current- 42%)</td>	
                                    <td>Rs. 19,992</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Travel Allowance</td>
                                    <td>
                                        <ul>
                                            <li>Cities- 3600</li>
                                            <li>Other Places- 1800</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowspan="3">Gross Salary Range (Approx)</td>
                                    <td>X Cities</td>
                                    <td>Rs. 1,15,936</td>
                                </tr>
                                <tr>	
                                    <td>Y Cities</td>
                                    <td>Rs. 1,09,824</td>
                                </tr>
                                <tr>
                                    <td>Z Cities</td>
                                    <td>Rs. 1,03,712</td>
                                </tr>
                                <tr>
                                    <td rowspan="3">In Hand Salary Range (Approx)</td>
                                    <td>X Cities</td>
                                    <td>Rs. 1,01,259</td>
                                </tr>
                                <tr>
                                    <td>Y Cities</td>
                                    <td>Rs. 96,136</td>
                                </tr>
                                <tr>	
                                    <td>Z Cities</td>
                                    <td>Rs. 91,012</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>DSSSB PGT Answer Key 2025</h4>
                        <p>The DSSSB Answer Key 2025 for PGT (Post Graduate Teacher) positions is expected to be released shortly after the examination. Candidates have to download the answer key to calculate their marks and raise any objections if necessary. The DSSSB Answer Key 2025 for PGT positions will be made available online by the board following the examination. Candidates will need to download the DSSSB PGT answer key for the various sets provided. There is no provision for re-evaluation/re-checking of Answer Sheets/Answer Scripts in respect of the examinations conducted by DSSSB. No correspondence in this regard shall be entertained.</p>

                        <h4>DSSSB PGT Result 2025</h4>
                        <p>The DSSSB PGT Result 2025 will be released online for all the subjects separately. The result along with the scorecard of the DSSSB PGT Recruitment has to be checked by the candidates to know about their selection status. The candidates have to download the scorecard using their login credentials. Those who successfully qualify for the DSSSB PGT final merit list will be considered for final appointment as Post Graduate Teachers.</p>

                        <h4>DSSSB PGT Cut Off Marks 2025</h4>
                        <p>Candidates have to download the DSSSB PGT Cut Off Marks 2025 after the authorities release it online. The minimum marks are released after considering several factors, such as total vacancies, exam difficulty level, and normalisation formula. Candidates whose marks in the exam are more than the prescribed Delhi PGT cutoff will be considered for the next round of document verification. The authorities are expected to release the subject-wise cut-off marks soon on the official website.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>Category</th>
                                    <th>DSSSB PGT Cut Off Marks 2025</th>
                                </tr>
                                <tr>
                                    <td>General/EWS</td>
                                    <td>40%</td>
                                </tr>
                                <tr>
                                    <td>OBC (Delhi)</td>
                                    <td>35%</td>
                                </tr>
                                <tr>
                                    <td>SC/ST/PH (PwBD)</td>
                                    <td>30%</td>
                                </tr>
                                <tr>
                                    <td>Ex-servicemen (within respective categories)</td>
                                    <td>5% relaxation (minimum 30%)</td>
                                </tr>
                            </tbody>
                        </table>

                        <img src={add1} className="courseBanner" alt="" />
                    </div>

                    <div className="col-lg-3">
                        <div className="sidebar-box">
                            <h5>Search</h5>
                            <div className="input-group mt-3">
                                <input type="text" className="form-control" placeholder="Enter Keyword" />
                                <button className="btn btn-light"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div className="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div className="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p className="mb-0"></p>
                                </div>
                            </div>
                            <img src={add2} className="courseBanner" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
export default AssistantprofessorCourse;